import "./App.css";
import { BrowserRouter as Router } from "react-router-dom";
import AppRoutes from "./routes/routes";
import { Zoom, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { PermissionProvider } from "./context/PermissionContext";

function App() {
  return (
    <div>
      <PermissionProvider>
        <Router>
          <AppRoutes />
        </Router>
      </PermissionProvider>
      <ToastContainer
        stacked
        closeOnClick
        position="top-center"
        autoClose="2000"
        theme="colored"
        transition={Zoom}
        hideProgressBar={true}
        newestOnTop={false}
        rtl={false}
        draggable
        pauseOnHover
      />
    </div>
  );
}

export default App;
